module.exports = __webpack_public_path__ + "static/media/Kudos_Family_Btn_Logo.4374e2d7.svg";